import React, { useContext, useState } from 'react';
import { Layout } from '../Layout';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { stackoverflowLight } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { IntlShape, useIntl } from 'react-intl';
import { Loading } from '../system/Loading';
import { MandantSettings } from '../../util/types';
import { StateContext } from '../../util/providers/StateProvider';

export interface PubligDocumentation {
  title: string;
  content: {
    title?: string;
    text?: string;
    code?: string;
  }[];
}


export const PublicDocumentationPage: React.FC = (): React.ReactNode => {
  const intl: IntlShape = useIntl();
  const mandantSettings: MandantSettings = useContext(StateContext).originMandantSettings;
  const [data, setData] = useState<PubligDocumentation>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const load = async (): Promise<void> => {
    setLoading(true);
    const doc: PubligDocumentation = await require(`../../Settings/mandants/${mandantSettings.mandant}/data-publig-doc.json`);
    setData(doc);
  };
  if (!loading && !data) {
    void load();
  }
  if (!data) {
    return <Loading/>;
  }
  return <Layout title={intl.formatMessage({id: data.title})}
                 headerImage={require('../../Settings/img/banners/publig.svg')}>
    <div className="flex flex-column gap-0 px-3">
      {data.content.map((content, idx) =>
        <div key={idx}>
          {content.title && <h3>{intl.formatMessage({id: content.title})}</h3>}
          {content.text && <div dangerouslySetInnerHTML={{__html: intl.formatMessage({id: content.text})}}/>}
          {content.code && <SyntaxHighlighter
            language="htmlbars"
            style={stackoverflowLight}
            customStyle={{
              'padding': '1em',
              'marginBottom': '0',
            }}>
            {`${intl.formatMessage({id: content.code})}`}
          </SyntaxHighlighter>}
        </div>,
      )}
    </div>
  </Layout>;
};

export default PublicDocumentationPage;
